import { Component, Input, OnInit, signal, WritableSignal } from '@angular/core';
import { Measurement, MeasurementType } from '@evident/ngx-media-viewer';
import { TranslateService } from '@ngx-translate/core';
import { TenantConfigService } from '../../../../../_services/http-api/tenant-config.service';
import { NetworkStatusService } from '../../../../../_services/network-status.service';
import { InspectionImageOfflineService } from '../../../../../_services/offline/inspection-image-offline.service';
import { TenantConfig, USE_IMAGE_TYPE } from '../../../../../app.constants';
import * as Measure from '../../../../../inspection-data-management/image-edit-dialog/measurement-merry/measurement.type';
import { PreviewImageDetail } from '../../../../models/report-preview/preview-image-detail';
import { MerryMeasurementParserService } from '../../../../../_services/merry-measurement-parser.service';
import { ReportMeasurementResult, LegacyReportMeasurementService } from '../../../../services/legacy-report-measurement.service';
import { from, mergeMap } from 'rxjs';

@Component({
  selector: 'app-report-measurement',
  templateUrl: './report-measurement.component.html',
  styleUrl: './report-measurement.component.scss',
  standalone: false
})
export class ReportMeasurementComponent implements OnInit {
  @Input({ required: true }) image: PreviewImageDetail | null = null;
  legacyMeasurementResults: ReportMeasurementResult[] = [];
  merryMeasurementResults: WritableSignal<Measurement[]> = signal([]);
  merryMeasurementEnabled = false;
  MeasurementType =  MeasurementType;
  unitSystem: Measure.UnitSystem = "Metric";

  constructor(
    private translate: TranslateService,
    private legacyMeasurementService: LegacyReportMeasurementService,
    private merryMeasurementParser: MerryMeasurementParserService,
    private inspectionImageService: InspectionImageOfflineService,
    private networkStatusService: NetworkStatusService,
    private tenantConfigService: TenantConfigService

  ) {
     this.merryMeasurementEnabled = this.networkStatusService.isBrianMode;
     this.setDefaultUnitSystem();
   }

  ngOnInit() {
    this.init();
  }

  private init() {
    if (this.image) {
     this.merryMeasurementEnabled ? this.setMerryMeasurements(): this.setLegacyMeasurements();
    }
  }

  private setLegacyMeasurements() {
    this.legacyMeasurementResults = this.legacyMeasurementService.toReportMeasurementResult(this.image?.measurementItems ?? []);
  }

  private async setMerryMeasurements() {
   const url = await this.inspectionImageService.getImageBinaryUrl(this.image.inspectionId, this.image.id, USE_IMAGE_TYPE.ORIGINAL);
   this.merryMeasurementParser.parseMeasurementResults(url).then(result => this.merryMeasurementResults.set(result));
  }

  public precision() {
    return Measure.precision(this.unitSystem);
  }

  public getUnitLabel(unit: Measure.UnitType): string {
    return Measure.getUnitLabel(unit, this.unitSystem);
  }

  public formatLegacyMeasurement(item: ReportMeasurementResult): string {
    const measurementNumber = item?.id.split(':')[0];

    const isArea = item.mode == 'area';
    const result = isArea ? item.result.area : item.result.length;
    const translationName = this.translate.instant(`imageRemeasurementEdit.${item.mode}`);
    const unit = isArea ? `${item.unit}^2` : item.unit;

    return `${measurementNumber}: ${translationName} ${result} ${unit}`;
  }

  setDefaultUnitSystem() {
    const unitSystemConfig = this.tenantConfigService.getConfigBykey(TenantConfig.DefaultUnitOfMeasurementResult.KEY);
    unitSystemConfig?.toLowerCase() === 'mm' ? this.unitSystem = 'Metric' : this.unitSystem = 'Imperial';
  }

}
